import React, { Component } from 'react';
import { Card, CardContent, CardActionArea, CardMedia } from '@mui/material';

export class PdfCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            doc: [],
            discussion: [],
            isError: false,
        };
    }

    async componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        const res = await fetch("/api/documentweb/" + this.props.discussRec.documentIdentifier, {
            headers: {
                "ClientIdentifier": this.props.discussRec.loan.clientIdentifier
            }
        });
        if (res.status === 200) {
            const results = await res.json();
            var obj = JSON.parse(results);
            this.setState({ doc: obj });

            if (obj.ERROR_MESSAGES != null) {
                this.setState({ isError: true })
            }
            else {
                this.props.docLoadCallback();
            }
        }       
        else {
            this.setState({ isError: true })
        }
    }

    render() {
        const { doc, isError } = this.state;
        return (
            <Card sx={{display: 'flex'}} >
                <CardActionArea>
                    <CardContent>
                        {(this.props.docLoaded) ?
                        (
                            <CardMedia
                                component="iframe"
                                width="1000"
                                height="850"
                                image={doc.SecureUrl}
                            />           
                        ):(
                        (isError) ?
                            (
                                <div>
                                    <h1>{"Unable to load Document"}</h1>
                                    <h3>{doc.ERROR_MESSAGES[0].ErrorMessageCategoryCode}</h3>
                                    <h3>{doc.ERROR_MESSAGES[0].ErrorMessageCode}</h3>
                                    <h3>{doc.ERROR_MESSAGES[0].ErrorMessageText}</h3>
                                </div>
                            ):(
                                <h1>Document Loading...</h1>                                 
                            )                         
                        )
                    }                   
                    </CardContent>
                </CardActionArea>
            </Card>
        );
    }
}